import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingIndicator } from '@components';
import { getRequerimentosStatus } from '../../../../store/requerimentos/thunks';

import { PageBody } from './components/PageBody';

export const EmAndamento = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.requerimentos.loadingStatus);

  useEffect(() => {
    dispatch(getRequerimentosStatus({ status: 'em andamento' }));
  }, [dispatch]);

  return isLoading ? <LoadingIndicator /> : <PageBody />;
};
